export default {
    options: {
        categories: {
            necessary: {
                enabled: true,  // this category is enabled by default
                readOnly: true  // this category cannot be disabled
            },
            analytics: {}
        },

        onConsent: ({cookie}) => {
            // This event is triggered the very first time the user expresses their choice of consent — just like onFirstConsent — but also on every subsequent page load.
            // console.log('Consent', cookie.categories);

            updateConsent(cookie);
        },

        onChange: ({cookie, changedCategories, changedServices}) => {
            // This event is triggered when the user modifies their preferences and only if consent has already been provided.
            // console.log('Change', cookie, changedCategories, changedServices);

            updateConsent(cookie);
        },

        guiOptions: {
            consentModal: {
                layout: 'box wide',
                position: 'bottom right',
                flipButtons: false,
                equalWeightButtons: true
            },
            preferencesModal: {
                layout: 'box',
                // position: 'left right',
                flipButtons: false,
                equalWeightButtons: true
            }
        },

        language: {
            default: 'nl',
            translations: {
                en: {
                    consentModal: {
                        title: 'We use cookies 123',
                        description: 'Cookie modal description',
                        acceptAllBtn: 'Accept all',
                        acceptNecessaryBtn: 'Reject all',
                        showPreferencesBtn: 'Manage Individual preferences'
                    },
                    preferencesModal: {
                        title: 'Manage cookie preferences',
                        acceptAllBtn: 'Accept all',
                        acceptNecessaryBtn: 'Reject all',
                        savePreferencesBtn: 'Accept current selection',
                        closeIconLabel: 'Close modal',
                        sections: [
                            {
                                title: 'Somebody said ... cookies?',
                                description: 'I want one!'
                            },
                            {
                                title: 'Strictly Necessary cookies',
                                description: 'These cookies are essential for the proper functioning of the website and cannot be disabled.',

                                //this field will generate a toggle linked to the 'necessary' category
                                linkedCategory: 'necessary'
                            },
                            {
                                title: 'Performance and Analytics',
                                description: 'These cookies collect information about how you use our website. All of the data is anonymized and cannot be used to identify you.',
                                linkedCategory: 'analytics'
                            },
                            {
                                title: 'More information',
                                description: 'For any queries in relation to my policy on cookies and your choices, please <a href="#contact-page">contact us</a>'
                            }
                        ]
                    }
                },
                nl: {
                    consentModal: {
                        title: 'We waarderen uw privacy',
                        description: 'De website maakt gebruik van eigen cookies om goed te kunnen functioneren.',
                        acceptAllBtn: 'Accepteer alles',
                        acceptNecessaryBtn: 'Alles weigeren',
                        showPreferencesBtn: 'Wijzigen'
                    },
                    preferencesModal: {
                        title: 'Manage cookie preferences',
                        acceptAllBtn: 'Accepteer alles',
                        acceptNecessaryBtn: 'Alles weigeren',
                        savePreferencesBtn: 'Opslaan',
                        closeIconLabel: 'Sluit',
                        sections: [
                            {
                                title: 'Cookie-instellingen',
                                description: 'Hieronder vindt u de details van de cookies die op onze website worden gebruikt.'
                            },
                            {
                                title: 'Noodzakelijk',
                                description: 'Deze cookies zijn essentieel voor het goed functioneren van onze website. Ze zorgen voor basisfunctionaliteiten en beveiligingsfuncties van de website, anoniem. Zonder deze cookies kunnen de door u gevraagde diensten, zoals transactiepagina\'s en beveiligde inlogaccounts, niet worden geleverd.',

                                //this field will generate a toggle linked to the 'necessary' category
                                linkedCategory: 'necessary'
                            },
                            {
                                title: 'Google Analitycs',
                                description: 'Deze cookies verzamelen informatie over hoe u onze website gebruikt, welke pagina\'s u hebt bezocht en op welke links u hebt geklikt. Alle gegevens zijn geanonimiseerd en kunnen niet worden gebruikt om u te identificeren. Ze worden gebruikt om de werking van een website te verbeteren. Door deze cookies toe te staan, helpt u ons u een betere ervaring te bieden. Optionele cookies op onze site omvatten Google Analytics voor verkeersanalyse op de site en Google AdWords voor het meten van de effectiviteit van advertentiecampagnes.',
                                linkedCategory: 'analytics'
                            },
                            // {
                            //     title: 'More information',
                            //     description: 'For any queries in relation to my policy on cookies and your choices, please <a href="#contact-page">contact us</a>'
                            // }
                        ]
                    }
                }
            }
        }
    },
};

function updateConsent(cookie) {
    window.dataLayer = window.dataLayer || [];

    let consent = {
        ad_storage: "denied",
        analytics_storage: "granted",
        ad_user_data: "denied",
        ad_personalization: "denied",
        personalization_storage: "denied",
        functionality_storage: "granted",
        security_storage: "granted"
    };

    // if cookie.categories contains 'analytics' then push the GTM event
    if (cookie.categories.includes('analytics')) {
        consent = {
            ad_storage: "granted",
            analytics_storage: "granted",
            ad_user_data: "granted",
            ad_personalization: "granted",
            personalization_storage: "granted",
            functionality_storage: "granted",
            security_storage: "granted"
        };
    }

    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments)}

    gtag("consent", "update", consent);
}
